<section *ngIf="processing">
    <h2>{{processingMessage}}...</h2>
    <mat-progress-bar mode="indeterminate" color="warn" aria-label="processing...">
    </mat-progress-bar>
</section>

<section *ngIf="!processing">
    <!-- Action Buttons --> 
        <div ng-include src="assets/docs/coc-letter-content.htmlfff"></div>
    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
        <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
            <h2 class="noMarginHeader"><mat-icon>note_add</mat-icon> Generate COC Letter - {{voucher.voucherId}}</h2>
        </div>
        <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
            <button type="submit" name="SubmitButton" (click)="onSubmitKendo()" mat-raised-button color="primary"
                value="Save" title="Save">Save</button>
            &nbsp;&nbsp;
            <button mat-button mat-dialog-close="Cancel" mat-raised-button color="basic"
                aria-label="Cancel">Cancel</button>
        </div>
    </div>
    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
        <div fxFlex="100.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
            <mat-form-field>
              <mat-label>Tests Required</mat-label>
              <mat-select [(value)]="letter.testsRequired">
                <mat-option>None</mat-option>
                <mat-option value="FullPanel">Full Panel</mat-option>
                <mat-option value="NitrateOnly">Nitrate Only</mat-option>
              </mat-select>
            </mat-form-field>
            &nbsp;&nbsp;
              <mat-form-field>
                <mat-label>Test Type</mat-label>
                <mat-select [(value)]="letter.testType">
                  <mat-option>None</mat-option>
                  <mat-option value="Initial">Initial</mat-option>
                  <mat-option value="Annual">Annual</mat-option>
                  <mat-option value="Quarterly">Quarterly</mat-option>
                </mat-select>
              </mat-form-field>
              
            &nbsp;&nbsp;
              <mat-form-field *ngIf="letter.testType == 'Quarterly'">
                <mat-label>Quarter</mat-label>
                <mat-select [(value)]="letter.quarter">
                  <mat-option value="0">None</mat-option>
                  <mat-option value="1">Q1</mat-option>
                  <mat-option value="2">Q2</mat-option>
                  <mat-option value="3">Q3</mat-option>
                  <mat-option value="4">Q4</mat-option>
                </mat-select>
              </mat-form-field>
        </div>
        
    </div>
    <hr />
</section>

<mat-dialog-content id="voucherLetterPdf">
  <div class="print-outer" >
    <div class="print-inner">
      <kendo-pdf-export #pdf paperSize="letter" paperSize="A4" margin="2cm" [scale]="0.4" forcePageBreak=".page-break">
        <ng-container [ngTemplateOutlet]="kendoTemplate"
                      [ngTemplateOutletContext]="{export: true}">
                    </ng-container>
      </kendo-pdf-export>
      </div>
  </div>
  <ng-template #kendoTemplate let-export="export">
    <style>
      
      .english-text  {
          font-family:  'SpanishLatin',  'SpanishLatinBold'  ;
          font-size: 20pt;
      }
      kendo-pdf-export {
          font-family:  Arial, Helvetica, sans-serif;
          font-size: 20pt;
        }
    </style>
    <section>
        <app-chain-of-custody-letter 
        [testsRequired]="letter.testsRequired" 
        [testType]="letter.testType" 
        [quarter]="letter.quarter"
        [wellAddress]="wellAddress"
        [customerName]="customerName"
        [mailingAddress]="mailingAddress"
        [mailingCity]="mailingCity"
        [mailingState]="mailingState"
        [mailingZip]="mailingZip"
        [phone]="phone"
        [email]="email"
        [voucherId]="voucher.voucherId"></app-chain-of-custody-letter>

    </section>

</ng-template>
</mat-dialog-content>